module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('y-shelf', {
    attrs: {
      "title": "我的优惠"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "padding": "100px 0",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/no-search.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "no-discount"
  }, [_vm._v("您目前还没有优惠券")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5d10eb4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/children/coupon.vue
// module id = 680
// module chunks = 0